export const fdpConductedData2020 = [
      {
        id: 1,
        fdp: "AICTE ATAL Sponsored FDP on Biomedical Engineering Systems and Technologies (Biosimilar Technologies)",
        faculty: "Amol S Deshpande",
        date: "23 - 27 Nov. 2020",
        duration: "5 days",
        participants: 139,
        manDays: 695,
        manHours: 3475,
      },
      {
        id: 2,
        fdp: "AICTE ATAL Sponsored FDP on Biomedical Engineering Systems and Technologies (Biosimilar Technologies)",
        faculty: "Milind Paraye",
        date: "23 - 27 Nov. 2020",
        duration: "5 Days",
        participants: 139,
        manDays: 695,
        manHours: 3475,
      },
      {
        id: 3,
        fdp: "AICTE ATAL Sponsored FDP on Biomedical Engineering Systems and Technologies (Biosimilar Technologies)",
        faculty: "Dayanand Ambawade",
        date: "23 - 27 Nov. 2020",
        duration: "5 Days",
        participants: 139,
        manDays: 695,
        manHours: 3475,
      },
      {
        id: 4,
        fdp: "AICTE ATAL Sponsored FDP on Biomedical Engineering Systems and Technologies (Biosimilar Technologies)",
        faculty: "Sneha Weakey",
        date: "23 - 27 Nov. 2020",
        duration: "5 Days",
        participants: 139,
        manDays: 695,
        manHours: 3475,
      },
      {
        id: 5,
        fdp: 'AICTE Sponsored STTP on "VLSI Design Using Cadence Tools: Digital CMOS VLSI Design and Verification"',
        faculty: "Sneha Weakey",
        date: "12th-17th Oct 2020",
        duration: "6 Days",
        participants: 46,
        manDays: 276,
        manHours: 1380,
      },
      {
        id: 6,
        fdp: 'AICTE Sponsored STTP on "VLSI Design Using Cadence Tools: Analog CMOS VLSI Design"',
        faculty: "Sneha Weakey",
        date: "2nd-7th Nov 2020",
        duration: "6 Days",
        participants: 60,
        manDays: 360,
        manHours: 1800,
      },
      {
        id: 7,
        fdp: 'AICTE Sponsored STTP on "VLSI Design Using Cadence Tools: Mixed Signal VLSI Design"',
        faculty: "Sneha Weakey",
        date: "30th Nov-5th Dec 2020",
        duration: "6 Days",
        participants: 43,
        manDays: 258,
        manHours: 1290,
      },
      {
        id: 8,
        fdp: 'AICTE Sponsored STTP on "VLSI Design Using Cadence Tools: Digital CMOS VLSI Design"',
        faculty: "Dr.Sukanya Kulkarni (program evaluation committee member)",
        date: "12th-17th Oct 2020",
        duration: "6 Days",
        participants: 43,
        manDays: 258,
        manHours: 1290,
      },
      {
        id: 9,
        fdp: 'AICTE Sponsored STTP on "VLSI Design Using Cadence Tools: Analog CMOS VLSI Design"',
        faculty: "Dr.Sukanya Kulkarni (program evaluation committee member)",
        date: "2nd-7th Nov 2020",
        duration: "6 Days",
        participants: 60,
        manDays: 360,
        manHours: 1800,
      },
      {
        id: 10,
        fdp: 'AICTE Sponsored STTP on "VLSI Design Using Cadence Tools: Mixed Signal VLSI Design"',
        faculty: "Dr.Sukanya Kulkarni (program evaluation committee member)",
        date: "30th Nov-5th Dec 2020",
        duration: "6 Days",
        participants: 43,
        manDays: 258,
        manHours: 1290,
      },
      {
        id: 11,
        fdp: "Expert lecture on “Image Classification “in IEEE SPIT WIE-WDC SPIT, and IETE Artificial Intelligence webinar Series",
        faculty: "Prof Vijaya Kamble",
        date: "25th May 2020",
        duration: "1 Hrs session",
        participants: "Youtube Live Around 200 participants",
        manDays: 200,
        manHours: 200,
      },
      {
        id: 12,
        fdp: 'AICTE Sponsored STTP on "VLSI Design Using Cadence Tools: Digital CMOS VLSI Design"',
        faculty: "Dr.Reena Sonkusare",
        date: "12th-17th Oct 2020",
        duration: "6 Days",
        participants: 43,
        manDays: 258,
        manHours: 1290,
      },
      {
        id: 13,
        fdp: 'AICTE Sponsored STTP on "VLSI Design Using Cadence Tools: Analog CMOS VLSI Design"',
        faculty: "Dr.Reena Sonkusare",
        date: "2nd-7th Nov 2020",
        duration: "6 Days",
        participants: 60,
        manDays: 360,
        manHours: 1800,
      },
      {
        id: 14,
        fdp: 'AICTE Sponsored STTP on "VLSI Design Using Cadence Tools: Mixed Signal VLSI Design"',
        faculty: "Dr.Reena Sonkusare",
        date: "30th Nov-5th Dec 2020",
        duration: "6 Days",
        participants: 43,
        manDays: 258,
        manHours: 1290,
      },
      {
        id: 15,
        fdp: 'Expert lecture in AICTE Sponsored STTP on "VLSI Design Using Cadence Tools: Mixed Signal VLSI Design"',
        faculty: "Dr.Reena Sonkusare",
        date: "4th Nov-5th Dec 2020",
        duration: "6 Days",
        participants: 60,
        manDays: 360,
        manHours: 360,
      },
    ];

export const fdpConductedData2021 = [
      {
        id: 16,
        fdp: "One Day Workshop on Sequel App",
        faculty: "Vijaya Kamble",
        date: "16th January2021",
        duration: "1 Day",
        participants: 60,
        manDays: 60,
        manHours: 360,
      },
      {
        id: 17,
        fdp: "International Conference on Communication information and Computing Technology (ICCICT)2021",
        faculty: "Dr. Sujata Kulkarni(Convener)",
        date: "25-27June 2021",
        duration: "3 day",
        participants: 200,
        manDays: 600,
        manHours: 3600,
      },
      {
        id: 18,
        fdp: "International Conference on Communication information and Computing Technology (ICCICT)2021",
        faculty: "Dr.Sukanya Kulkarni (Registration chair)",
        date: "25-27June 2021",
        duration: "3 day",
        participants: 200,
        manDays: 600,
        manHours: 3600,
      },
      {
        id: 19,
        fdp: "International Conference on Communication information and Computing Technology (ICCICT)2021",
        faculty: "Dr. Reena Sonkusare(Tutorial Track coordinator)",
        date: "25-27June 2021",
        duration: "3 day",
        participants: 200,
        manDays: 600,
        manHours: 3000,
      },
      {
        id: 20,
        fdp: "International Conference on Communication information and Computing Technology (ICCICT)2021",
        faculty: "Dr. Reena Sonkusare(Industry relation co-chair)",
        date: "25-27June 2021",
        duration: "3 day",
        participants: 200,
        manDays: 600,
        manHours: 3000,
      },
    ];
